<template >
  <div class="bodyback min-vh-100">
    <notifications></notifications>

    <div class="overimg"></div>

    <div class="main-content mt-0">
      <div class="container pb-0">
        <div
          class="
            row row
            align-items-center
            justify-content-center
            d-flex
            vh-100
          "
        >
          <div class="col-lg-5 col-md-7">
            <div class="card mb-0">
              <div class="card-header mb-3">
                <div class="text-dark text-center">
                  <h1 class="title-one mb-2">
                    <strong>Recover Password</strong>
                  </h1>

                  <img
                    src="@/assets/img/rhombuss-dispath-pos.png"
                    alt="rhombuss"
                    class="logo-home d-block text-center"
                  />
                </div>
              </div>
              <div class="card-body px-lg-4">
                <span class="d-block f2 text-center mb-3"
                  >Enter a new password to recover your account</span
                >
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <form
                    role="form"
                    @submit.prevent="handleSubmit(recoverPassword)"
                  >
                    <div class="col-12">
                      <label for="newPassword" class="title-label">
                        Password
                        <el-popover placement="top" trigger="hover" width="300">
                          <p class="form-control-label mb-2">
                            <i class="flaticon-lock-1 mr-2"></i>
                            <strong>Strong Password</strong>
                          </p>
                          <ul class="ul-pop">
                            <li>Minimum 8 characters</li>
                            <li>1 Uppercase Letter</li>
                            <li>1 Lowercase Letter</li>
                            <li>1 Number</li>
                            <li>1 Special Character (Ex. @ # $ %)</li>
                          </ul>
                          <div class="badge badge-primary" slot="reference">
                            <i
                              class="laticon-question-1 icon-min-badge white"
                            ></i>
                          </div>
                        </el-popover>
                      </label>

                      <base-input
                        label="Password"
                        placeholder="Password"
                        class="no-label"
                        :rules="{
                          required: true,
                          min: 8,
                          max: 15,
                          regex:
                            /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,15}$/,
                        }"
                        name="password"
                        type="password"
                        success="Password Strong"
                        v-model="data.password"
                      ></base-input>
                    </div>

                    <div class="col-12 mb-3">
                      <base-input
                        class="mb-3"
                        label="Confirm Password"
                        placeholder="Confirm Password"
                        :rules="{
                          required: true,
                          min: 8,
                          max: 15,
                          regex:
                            /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,15}$/,
                          confirmed: 'password',
                        }"
                        name="confirm-password"
                        type="password"
                        v-model="data.repeatPassword"
                      ></base-input>
                    </div>

                    <div class="text-center">
                      <base-button
                        type="primary"
                        native-type="submit"
                        size="sm"
                        class="mt-4"
                        >Accept</base-button
                      >
                    </div>
                  </form>
                </validation-observer>

                <div class="loading mt-3" v-if="load">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-12"></div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 pt-2 pb-2">
                <router-link to="/login" class="text-light font-weight-600"
                  >Sign Up</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import layoutFooter from "../Theme/Layout/ContentFooter";
import Swal from "sweetalert2";
import endpoint from "../../Commons/Services";
export default {
  components: {
    layoutFooter: layoutFooter,
  },
  data() {
    return {
      data: {
        password: "",
        repeatPassword: "",
      },
      load: false,
      type: "",
      token: "",
      _id: "",
    };
  },
  created() {
    this._id = this.$route.query.id ? this.$route.query.id : null;
    this.type = this.$route.query.type_user
      ? this.$route.query.type_user
      : null;

    this.token = this.$route.query.token ? this.$route.query.token : "";
  },
  methods: {
    async recoverPassword() {
      const isValid = await this.$refs.formValidator.validate();
      if (isValid) {
        this.load = true;
        try {
          let { data } = await endpoint.auth.services.restorePassword(
            this._id,
            this.data,
            this.type,
            this.token
          );
          if (data.status) {
            this.load = false;
            let result = await Swal.fire({
              title: "Success",
              html: "You can now log in with your new password",
              imageUrl: "../../img/icons/alerts/success.png",
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              confirmButtonClass: "btn btn-primary btn-small-one",
            });

            if (result.value) {
              this.$router.push("/login");
            } else {
              this.$router.push("/login");
            }
          } else {
            this.load = false;
            let result = await Swal.fire({
              title: "Error",
              html: 'An error occurred while saved your changes,<br> try again or <a href="https://www.rhombuss.com/contact" target="blank">Contact us</a>',
              imageUrl: "../../img/icons/alerts/error.png",
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              confirmButtonClass: "btn btn-primary btn-small-one",
            });
            if (result.value) {
              this.$router.push("/login");
            } else {
              this.$router.push("/login");
            }
          }
        } catch (error) {
          this.load = false;
          let result = await Swal.fire({
            title: "Error",
            html: 'An error occurred while saved your changes,<br> try again or <a href="https://www.rhombuss.com/contact" target="blank">Contact us</a>',
            imageUrl: "../../img/icons/alerts/error.png",
            buttonsStyling: false,
            focusConfirm: false,
            reverseButtons: true,
            confirmButtonText: "Accept",
            confirmButtonClass: "btn btn-primary btn-small-one",
          });
          if (result.value) {
            this.$router.push("/login");
          } else {
            this.$router.push("/login");
          }
        }
      }
    },
    ...mapMutations(["setLoader"]),
  },
  computed: {
    ...mapGetters(["loader"]),
  },
};
</script>
